import React, {Component} from 'react';
import './styles/App.scss';
import API from "./api";
import ChatBot from "./lib";
import {ThemeProvider} from 'styled-components';


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            settings: {
                enabled:false,
                language:'en',
                floatingText:'Start Chat',
                texts:{
                    selectAppointmentYouWantCancel: '',
                    selectAppointmentYouWantReschedule: '',
                },
            },
            stepsMsg: null,
            steps: null,
            styles:{
                background: '#f5f8fb',
                fontFamily: 'Arimo, sans-serif',
                headerBgColor: '#6e48aa',
                headerFontColor: '#fff',
                headerFontSize: '16px',
                botBubbleColor: '#6E48AA',
                botFontColor: '#fff',
                userBubbleColor: '#fff',
                userFontColor: '#4a4a4a',
                userLoginHeaderColor: '#000'
            }
        };

        this.changeHeaderColorAction = this.changeHeaderColorAction.bind(this);
    }
    componentWillMount() {
        var self =this;


        API.get('/getChatBotSettings').then((res) => {
            const result = res.data;

            if (result.status == "success") {
                let color_setting = {...self.state.styles,...result.data.color};
                this.setState(
                    {
                        settings: result.data.settings,
                        stepsMsg: result.data.steps,
                        styles: color_setting,
                    },this.setStepsMessages
                );
                API.isPatientVerify().then((result) => {

                    if (result.validateLogin) {
                        this.changeHeaderColorAction();
                    }
                });
            }

        }).catch((error) => {
            this.setState({
                error: 'Error retrieving data',
                loading: false
            });
        });




    }



    isYesNoOptions(text) {
        return text.indexOf('yes_no') !== -1;
    }

    setStepsMessages() {

        let new_steps = this.props.steps.map(obj => {
            var self = this;

            if (typeof obj.optionsForTranslate != "undefined" && obj.optionsForTranslate) {
                obj.metadata.options = obj.metadata.options.map((opt_obj) => {
                    var option_id = obj['id'];
                    let option_name = 'options_' + option_id + '_' + opt_obj.value;
                    if (typeof self.state.stepsMsg[option_name] != "undefined") {
                        opt_obj.label = self.state.stepsMsg[option_name];
                    }else{
                        console.log("not found translate for: " + option_name)
                    }
                    return opt_obj;
                }, obj);
            }else if (typeof obj.options != "undefined") {
                if (this.isYesNoOptions(obj.id)) {
                    obj.options = obj.options.map((opt_obj) => {
                        if (opt_obj.value == 1 && typeof self.state.stepsMsg['button_yes'] != "undefined") {
                            opt_obj.label = self.state.stepsMsg['button_yes'];
                        } else if (opt_obj.value == 0 && typeof self.state.stepsMsg['button_no'] != "undefined") {
                            opt_obj.label = self.state.stepsMsg['button_no'];
                        }
                        return opt_obj;
                    }, obj);
                } else {
                    obj.options = obj.options.map((opt_obj) => {
                        var option_id = obj['id'];
                        let option_name = 'options_' + option_id + '_' + opt_obj.value;
                        if (typeof self.state.stepsMsg[option_name] != "undefined") {
                            opt_obj.label = self.state.stepsMsg[option_name];
                        }
                        return opt_obj;
                    }, obj);
                }
            } else if (typeof this.state.stepsMsg[obj.id] != "undefined") {
                if (typeof obj.component != "undefined") {
                    obj.metadata = this.state.stepsMsg[obj.id];
                } else {
                    obj.message = this.state.stepsMsg[obj.id];
                }
            }

            return obj;
        });

        this.setState({
            loading: false,
            steps: new_steps
        });
    }

    changeHeaderColorAction(){

        this.setState(
            {styles: {...this.state.styles, "headerBgColor": this.state.styles.userLoginHeaderColor}}
        );
    }

    render() {
        const {loading, settings, steps,styles,generalInfo} = this.state;
        if (!loading) {
            return (
                <ThemeProvider theme={styles}>
                    <ChatBot
                        steps={steps}
                        className={`PlexidocChatBot lang-${settings.language}`}
                        floating={true}
                        settings={settings}
                        enableMobileAutoFocus={true}
                        headerTitle={settings.headerTitle}
                        placeholder={settings.placeholder}
                        startAgainButton={settings.startAgainButton}
                        prevStepButton={settings.prevStepButton}
                        floatingText = {settings.floatingText}
                        changeHeaderColorAction = {this.changeHeaderColorAction}
                    />
                </ThemeProvider>
            );
        } else {
            return (
                <div></div>
            );
        }
    }
}

export default App;
